<template>
  <v-chart
    class="v-chart"
    :options="options"
    :init-options="{}"
    autoresize />
</template>

<script>
import ECharts from '@/components/public/ECharts.vue'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
export default {
  name: 'InOutStockChart',
  components: {
    'v-chart': ECharts
  },
  props: {
    xAxis: {
      type: Array,
      default() {
        return []
      }
    },
    series1: {
      type: Array,
      default() {
        return []
      }
    },
    series2: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
    }
  },
  computed: {
    options() {
      return {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['本期入库数量', '本期出库数量']
        },
        xAxis: [
          {
            type: 'category',
            data: this.xAxis,
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              rotate: 45
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            min: 0,
            axisLabel: {
              formatter: '{value}件'
            }
          }
        ],
        series: [
          {
            name: '本期入库数量',
            type: 'bar',
            data: this.series1
          },
          {
            name: '本期出库数量',
            type: 'bar',
            data: this.series2
          }
        ]
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-chart {
    height 300px!important
}
</style>
